import React from 'react';

import {
    Close,
    Visibility,
    VisibilityOff,
    AccountCircleRounded,
    ManageAccountsOutlined,
    PaymentOutlined,
    SettingsOutlined,
    LogoutOutlined,
    Replay,
    AlternateEmailOutlined,
    PhoneAndroidOutlined,
    LocationOnOutlined,
    BusinessOutlined,
    BadgeOutlined,
    PublicOutlined,
    ChevronLeft,
    CreditCardOffOutlined,
    VerifiedUserOutlined,
    LockOutlined,
    FilterAltOff,
    FilterAlt,
    Search,
    SearchOff,
    LanguageOutlined,
    AccessTimeOutlined,
    ModeEdit,
    FiberManualRecord,
    SortOutlined,
    SouthOutlined,
    NorthOutlined,
    Circle,
    InfoOutlined,
    MoneyOff,
    Speed,
    NewReleases,
    SupportAgent,
    TrendingUp,
    SimCardDownload,
    UploadFile,
    ToggleOn,
    ToggleOff,
    MoreVert,
    Category,
    Groups,
    Hotel,
    Payment,
    Add,
    Edit,
    Delete,
    ContentCopy,
    Info,
    DateRange,
    Face,
    ChildCare,
    ChildFriendly,
    Girl,
    Face3,
    Preview,
    Error,
    ReportProblem,
    NotInterested,
    Message,
    Email,
    Person,
    Event,
    Apartment,
    StickyNote2,
    Battery0Bar,
    Battery6Bar,
    Battery4Bar,
    Battery1Bar,
    Today,
    ContentPaste,
    Assignment,
    EditCalendar,
    Newspaper,
    EventNote,
    Bed,
    GppBad,
    Payments,
    Paid,
    Restaurant,
    Star,
    StarHalf,
    StarOutline,
    Description,
    DryCleaning,
    List,
    CardMembershipOutlined,
    RadioButtonUnchecked,
    CircleOutlined,
    CheckCircle,
    OpenInNew,
    AutoFixHigh,
    AddPhotoAlternate,
    ViewInAr,
    RoomService,
    People,
    Fastfood,
    Image,
    MeetingRoom,
    KeyboardArrowDown,
    KeyboardArrowUp,
    InsertChartOutlined,
    ListAlt,
    RequestQuote,
} from '@mui/icons-material';
import Tooltip from './Tooltip';

const Icon = props => {
    const { iconName, titleText, tooltipProps, ...restProps } = props;
    const icons = {
        Close,
        Visibility,
        VisibilityOff,
        AccountCircleRounded,
        ManageAccountsOutlined,
        PaymentOutlined,
        SettingsOutlined,
        LogoutOutlined,
        Replay,
        AlternateEmailOutlined,
        PhoneAndroidOutlined,
        LocationOnOutlined,
        BusinessOutlined,
        BadgeOutlined,
        PublicOutlined,
        ChevronLeft,
        CreditCardOffOutlined,
        VerifiedUserOutlined,
        LockOutlined,
        FilterAltOff,
        FilterAlt,
        Search,
        SearchOff,
        LanguageOutlined,
        AccessTimeOutlined,
        ModeEdit,
        FiberManualRecord,
        SortOutlined,
        SouthOutlined,
        NorthOutlined,
        Circle,
        InfoOutlined,
        MoneyOff,
        Speed,
        NewReleases,
        SupportAgent,
        TrendingUp,
        SimCardDownload,
        UploadFile,
        ToggleOn,
        ToggleOff,
        MoreVert,
        Category,
        Groups,
        Hotel,
        Payment,
        Add,
        Edit,
        Delete,
        ContentCopy,
        Info,
        DateRange,
        Face,
        ChildCare,
        ChildFriendly,
        Girl,
        Face3,
        Preview,
        Error,
        ReportProblem,
        NotInterested,
        Message,
        Email,
        Person,
        Event,
        Apartment,
        StickyNote2,
        Battery0Bar,
        Battery6Bar,
        Battery4Bar,
        Battery1Bar,
        Today,
        ContentPaste,
        Assignment,
        EditCalendar,
        Newspaper,
        EventNote,
        Bed,
        GppBad,
        Payments,
        Paid,
        Restaurant,
        Star,
        StarHalf,
        StarOutline,
        Description,
        DryCleaning,
        List,
        CardMembershipOutlined,
        RadioButtonUnchecked,
        CircleOutlined,
        CheckCircle,
        OpenInNew,
        AutoFixHigh,
        AddPhotoAlternate,
        ViewInAr,
        RoomService,
        People,
        Fastfood,
        Image,
        MeetingRoom,
        KeyboardArrowDown,
        KeyboardArrowUp,
        InsertChartOutlined,
        ListAlt,
        RequestQuote,
    };

    const IconComponent = icons[iconName];

    const awesomeFontClassName = `${iconName} ${restProps?.className}`;

    const icon = () => {
        if (IconComponent) {
            return <IconComponent fontSize='small' {...restProps} />;
        }
        return <i {...restProps} className={awesomeFontClassName} />;
    };

    if (titleText)
        return (
            <Tooltip titleText={titleText} {...tooltipProps}>
                {icon()}
            </Tooltip>
        );
    return <>{icon()}</>;
};

export default Icon;
